export default __webpack_public_path__ + "static/media/viability.38232fd2.svg";